module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "loadingtext"
  }, [_vm._v(_vm._s(_vm.loadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])]), _vm._v(" "), _c('div', {
    staticClass: "togglebutton clearfix"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    ref: "togglebutton",
    staticClass: "checked",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        _vm.togglebuttonSelect()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('span', {
    staticClass: "selcteditem"
  }, [_vm._v(_vm._s(_vm.currenttoggle))])]), _vm._v(" "), _c('div', {
    staticClass: "salesblock clearfix"
  }, [_c('div', {
    staticClass: "highlitboxes basesales totalspent"
  }, [_vm._v("Total Spend\n      "), _vm._m(0), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.TotalSpent))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareTotalSpent) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareTotalSpentArrow === 1 ? 'fa-caret-up green' : _vm.CompareTotalSpentArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes"
  }, [_vm._v("Non Media " + _vm._s(_vm.kpi) + "\n      "), _vm._m(1), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.BaseSales))])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes medadsale togglerBoxes active"
  }, [_vm._v("Paid Media " + _vm._s(_vm.Tkpi) + "\n      "), _vm._m(2), _vm._v(" "), _c('b', {
    staticClass: "MediaDrivenSales"
  }, [_vm._v(_vm._s(_vm.MediaDrivenSales))]), _vm._v(" "), _c('b', {
    staticClass: "MediaDrivenROI"
  }, [_vm._v(_vm._s(_vm.MediaDrivenROI))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareMediaDrivenSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareMediaDrivenSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareMediaDrivenSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes ecosyssales togglerBoxes active"
  }, [_vm._v("O/E Ecosystem " + _vm._s(_vm.Tkpi) + "\n      "), _vm._m(3), _vm._v(" "), _c('b', {
    staticClass: "EcosystemSales"
  }, [_vm._v(_vm._s(_vm.EcosystemSales))]), _vm._v(" "), _c('b', {
    staticClass: "EcosystemROI"
  }, [_vm._v(_vm._s(_vm.EcosystemROI))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareEcosystemSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareEcosystemSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareEcosystemSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes tsales"
  }, [_vm._v("Total " + _vm._s(_vm.kpi) + "\n      "), _vm._m(4), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.TotalSales))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareTotalSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareTotalSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareTotalSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "chartarea",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "tooltip",
    staticClass: "tooltip2"
  }, [_vm._v(_vm._s(_vm.tooltipcontent))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mynetwork"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "report-anualspent"
  }, [_vm._v("Annual Spend")]), _vm._v(" "), _c('div', {
    staticClass: "report-max-uplift"
  }, [_vm._v("Max Uplift: " + _vm._s(_vm.currentnest_name))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix leftside"
  }, [_c('div', {
    staticClass: "slidertop clearfix"
  }, _vm._l((_vm.sliderinputval), function(sliderinputval, index) {
    return _c('div', _vm._b({
      key: sliderinputval.name,
      staticClass: "slider-wrapper"
    }, 'div', sliderinputval, false), [_c('label', [_vm._v(" " + _vm._s(sliderinputval.name))]), _vm._v(" "), _c('vue-slider', _vm._b({
      ref: 'slider' + index,
      refInFor: true,
      attrs: {
        "max": sliderinputval.max_value,
        "label": sliderinputval.name
      },
      on: {
        "callback": function($event) {
          _vm.checkslider(sliderinputval, $event)
        }
      },
      scopedSlots: _vm._u([{
        key: "tooltip",
        fn: function(ref) {
          var spend = ref.spend;

          return _c('div', {
            staticClass: "slider-tooltip"
          })
        }
      }]),
      model: {
        value: (sliderinputval.spend),
        callback: function($$v) {
          _vm.$set(sliderinputval, "spend", $$v)
        },
        expression: "sliderinputval.spend"
      }
    }, 'vue-slider', _vm.slideroptions, false)), _vm._v(" "), _c('div', {
      staticClass: "slider-text"
    }, [_c('input', {
      attrs: {
        "pattern": "^[\\d,]+$",
        "type": "text"
      },
      domProps: {
        "value": index = sliderinputval.spend.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      },
      on: {
        "input": function($event) {
          _vm.updateSlider(sliderinputval, $event)
        }
      }
    })])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "optimiseWidgetWrapper"
  }, [_c('div', {
    staticClass: "inputOptimizeNamr view"
  }, [_c('a', {
    staticClass: "verclosebutton",
    on: {
      "click": function($event) {
        _vm.verclosebutton()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.versionName),
      expression: "versionName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "optimname",
      "placeholder": "Optimisation Version Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.versionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.versionName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "reportbutton optimiseBtnGO",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.NewOptimisebtntrigger()
      }
    }
  }, [_vm._v("GO")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down optiarrow",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton optimiseBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.NewOptimisebtnClick()
      }
    }
  }, [_vm._v("Optimise")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix excelwrapper reportpageexcelwrapper"
  }, [_c('HotTable', {
    staticClass: "handsontable handsontableReport",
    attrs: {
      "root": _vm.root,
      "settings": _vm.hotSettings,
      "observeChanges": "true",
      "onAfterChangesObserved": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "reportbuttonwrapper clearfix"
  }, [_c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.updateBtnDisable
    },
    on: {
      "click": function($event) {
        _vm.UpdatebtnClick('update')
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savebuttonclick
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton resetreportBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetbtnClick()
      }
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('div', {
    staticClass: "helpertable"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Model Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.modelname))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Market")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.country))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Category")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.category))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelVesrionSelect),
      expression: "modelVesrionSelect"
    }],
    ref: "versionsCombo",
    staticClass: "form-control",
    attrs: {
      "id": "modelVesrionSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modelVesrionSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.modelVesrionSelectChanged()
      }]
    }
  }, _vm._l((_vm.versions), function(versions, index) {
    return (versions.version_status === 'completed' ? 'disable' : '') ? _c('option', {
      key: versions.version_id,
      attrs: {
        "disabled": false
      },
      domProps: {
        "selected": index === 0 ? true : false,
        "value": index
      }
    }, [_vm._v(_vm._s(versions.text))]) : _vm._e()
  }))])])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "heading",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Version\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f462298"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Report.vue
// module id = 317
// module chunks = 1